import {  useEffect } from "react"

const UserBrandType = ({ x }) => {

    useEffect(() => {
        // console.log("USERBRANDTYPE")
    }, [])

    if (x.all_entities || ["owner", "admin"].includes(x.role)) return <span>All Brands/Accounts</span>

    else {
        let count = x.entity_id_list ? x.entity_id_list.length : 0
        let brandAccount = count > 1 ? "Brands/Accounts" : "Brand/Account"
        return <span>{count > 0 ? count : "No"} {brandAccount}</span>
    }

}
export default UserBrandType